import { useFeatureValue } from '@growthbook/growthbook-react';
import { useMemo } from 'react';
import { FEATURE_FLAG } from '../../constants/featureFlags';
import { PaymentTransactionType, PAYMENT_TRANSACTION_TYPE } from '../../types/enums';
import { PaymentProvider } from '../../types/payment';

type GatewayConfig = {
  id: string;
  providers: { id: string; name: string }[];
};

const usePaymentProviders = (
  paymentProviders: PaymentProvider[],
  transactionType: PaymentTransactionType,
  paymentGateway: string
) => {
  const paymentGatewayOptions = useFeatureValue<GatewayConfig[]>(FEATURE_FLAG.PAYMENT_GATEWAY_OPTIONS, []);

  const filteredProviders = useMemo(() => {
    const gatewayConfig = paymentGatewayOptions.find((gateway) => gateway.id === paymentGateway);
    const enabledProviders = gatewayConfig?.providers.map((provider) => provider.id);
    const hasEnabledProvidersFilter = !!enabledProviders?.length;

    return paymentProviders.filter((provider) => {
      const providerIds = [provider.value, ...(provider.aliases ?? [])];
      const isEnabled = !hasEnabledProvidersFilter || providerIds.some((id) => enabledProviders.includes(id));
      if (!isEnabled) {
        return false;
      }

      if (transactionType === PAYMENT_TRANSACTION_TYPE.WITHDRAW) {
        return !provider.disableWithdraw;
      }

      return true;
    });
  }, [paymentProviders, transactionType, paymentGatewayOptions, paymentGateway]);

  return filteredProviders;
};

export default usePaymentProviders;
